import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=b560974c&"
import script from "./RatingDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b560974c')) {
      api.createRecord('b560974c', component.options)
    } else {
      api.reload('b560974c', component.options)
    }
    module.hot.accept("./RatingDisplay.vue?vue&type=template&id=b560974c&", function () {
      api.rerender('b560974c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8kD9KJrWUUtqS/JS/comp/RatingDisplay.vue"
export default component.exports